import React, { useEffect, useState } from 'react';
import { academicProgramsService } from '../../../services';
import { RequestDetailsPanel } from '../../../components/academic-affair-program-requests/components/view/RequestDetailsPanel';
import { InstitutionRequestLogHistory } from '../../../components/academic-affair-program-requests/components/institution/program-requests-institution-RequestLogs';
import eventEmitter from '../../../shared/eventEmitter';

export const ProgramRequestInstitutionViewPage = props => {
    const [programRequestLogData, setProgramRequestLogData] = useState([]);
    const [currentRequestData, setCurrentRequestData] = useState([]);
    const [requestId, setRequestId] = useState(-1);

    useEffect(() => {
        const query = props.location.state;
        if (query) {
            for (let param of query) {
                setCurrentRequestData(param.data);
                setRequestId(param.data.requestID);
            }
        }
    }, [props.location.state]);

    useEffect(() => {
        if (requestId === -1) return;
        const res = academicProgramsService.getProgramRequestLogs(requestId);
        Promise.resolve(res).then(data => {
            setProgramRequestLogData(data ?? []);
        });
    }, [requestId]);

    useEffect(() => {
        if (requestId === -1) return;
        const handleDataUpdate = () => {
            const res = academicProgramsService.getProgramRequestLogs(requestId);
            Promise.resolve(res).then(data => {
                setProgramRequestLogData(data ?? []);
            });
        };
        eventEmitter.on('updateSARData', handleDataUpdate);
        return () => {
            eventEmitter.off('updateSARData', handleDataUpdate);
        };
    }, [requestId]);

    return (
        <div className="program-request-details">
            <RequestDetailsPanel
                requestDetails={currentRequestData}
                requestLogs={programRequestLogData}
                showBackButton={true}
            >
                <InstitutionRequestLogHistory
                    requestLogs={programRequestLogData}
                    requestStatus={currentRequestData.status}
                    requestDetails={currentRequestData}
                />
            </RequestDetailsPanel>
        </div>
    );
};
